import { HIDE, SHOW, ENABLE, DISABLE } from 'constants/OnScreenKeyboard';

export const hideKeyboard = () => ({ type: HIDE });
export const showKeyboard = () => ({ type: SHOW });
export const setKeyboardVisibility = visible => ({
  type: visible ? SHOW : HIDE,
});

export const enableKeyboard = () => ({ type: ENABLE });
export const disableKeyboard = () => ({ type: DISABLE });
export const setKeyboardEnabled = enabled => ({
  type: enabled ? ENABLE : DISABLE,
});
